/* In-wizard help button — opens a slide-over panel with the tool's documentation
 * without leaving the wizard. Use anywhere a tool wizard is being run.
 */
import { useState } from "react";
import { Link } from "react-router-dom";
import { HelpCircle, X, ExternalLink } from "lucide-react";
import DocBody from "./DocBody";
import { TOOL_DOCS_BY_ID } from "../docs/toolDocs";

export default function DocHelpButton({ toolId, label = "Docs" }) {
  const [open, setOpen] = useState(false);
  const doc = TOOL_DOCS_BY_ID[toolId];
  if (!doc) return null;

  return (
    <>
      <button
        data-testid={`doc-help-${toolId}`}
        onClick={() => setOpen(true)}
        title="Open tool documentation"
        className="inline-flex items-center gap-1.5 text-xs font-semibold text-sage-600 hover:text-sage-900 border border-sage-200 hover:border-sage-400 rounded-md px-2.5 py-1.5 transition-colors"
      >
        <HelpCircle className="w-3.5 h-3.5" /> {label}
      </button>

      {open && (
        <div
          data-testid={`doc-help-panel-${toolId}`}
          className="fixed inset-0 z-50 flex justify-end bg-black/30"
          onClick={() => setOpen(false)}
        >
          <aside
            onClick={(e) => e.stopPropagation()}
            className="bg-white w-full max-w-2xl h-full shadow-xl overflow-y-auto animate-slide-in-right"
          >
            <div className="sticky top-0 bg-white border-b border-sage-100 px-6 py-3 flex items-center justify-between z-10">
              <p className="text-xs uppercase tracking-wider text-sage-500 font-semibold">Tool Documentation</p>
              <div className="flex items-center gap-2">
                <Link
                  to={`/docs/${toolId}`}
                  data-testid={`doc-help-fullpage-${toolId}`}
                  className="text-xs text-sage-600 hover:text-sage-900 inline-flex items-center gap-1"
                  onClick={() => setOpen(false)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open full page <ExternalLink className="w-3 h-3" />
                </Link>
                <button
                  data-testid={`doc-help-close-${toolId}`}
                  onClick={() => setOpen(false)}
                  className="text-sage-400 hover:text-sage-700"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
            </div>
            <div className="p-6">
              <DocBody doc={doc} compact />
            </div>
          </aside>
        </div>
      )}
    </>
  );
}
